<template>
  <div class="autocomplete-wrapper">
    <div class="inner">
      <p class="label-filter">Ricerca guidata: </p>
      
      <input id="free-search-input" 
        autocomplete="off" 
        aria-autocomplete="list" 
        @focus="isResultsVisible = query.length > 1"
        @blur="isResultsVisible = false" 
        @input="update" 
        v-model="query">

      <div class="results" v-if="results" :class="{active: isResultsVisible}">
        <div class="block" v-if="results.albums && results.albums.length">
          <span>Album</span>
          <ul>
            <li v-for="result in results.albums" :key="result.id"> 
              <a href="#0" @click.prevent="trigger(result)"><span>{{result.title}} - {{result.artist}}</span></a>
            </li>
          </ul>
        </div>

        <div class="block" v-if="results.songs && results.songs.length">
          <span>Brani</span>
          <ul>
            <li v-for="result in results.songs" :key="result.id">
              <a href="#0" @click.prevent="trigger(result)"><span>{{result.title}} - {{result.artist}}</span></a>  
            </li>
          </ul>
        </div>

        <div class="block" v-if="results.artists && results.artists.length">
          <span>Artisti</span>
          <ul>
            <li v-for="result in results.artists" :key="result.id">
              <a href="#0" @click.prevent="trigger(result)"><span>{{result.name}}</span></a>  
            </li>
          </ul>
        </div>

        <div class="block" v-if="results.genres && results.genres.length">
          <span>Generi</span>
          <ul>
            <li v-for="result in results.genres" :key="result.id">
              <a href="#0" @click.prevent="trigger(result)"><span>{{result.name}}</span></a>  
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios/dist/axios';

export default {
  data() {
    return {
      query: '',
      results: {},
      isResultsVisible: false
    }
  },

  methods: {
    update: function(e) {
      if(this.query.length > 1) {
        axios.get('/api/v1/search/autocomplete?q=' + this.query)
          .then(resp => {
            const d = resp.data;
            
            const albums = d.albums.map(album => ({
              title: album.title,
              artist: album.artist.name,
              slug: album.slug,
              type: 'album'
            }));

            const genres = d.genres.map(genre => ({
              name: genre.name,
              id: genre.id,
              type: 'genre'
            }));

            const artists = d.artists.map(artist => ({
              name: artist.name,
              id: artist.id,
              type: 'artist'
            }));

            const songs = d.songs.map(song => ({
              title: song.title,
              artist: song.album.artist.name,
              slug: song.slug,
              type: 'song'
            }));

            this.results = {albums, genres, artists, songs};
            this.isResultsVisible = true;
          })
          .catch(err => {
            this.isResultsVisible = false;
          });
      } else {
        this.isResultsVisible = false;
      }
    },

    trigger: function(result) {
      // emit new search
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

      this.isResultsVisible = false;
      this.$eventBus.$emit('autocomplete:update', result);
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';

.autocomplete-wrapper {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--mobile-padding);
}

@media (min-width: 1024px) {
  .autocomplete-wrapper {
    padding: 0 var(--desktop-padding);
  }
}

.label-filter{
	display: inline-block;
	font-size: 16px;
  font-family: Arial;
  text-transform: uppercase;
  letter-spacing: 0px;	
	padding: 10px 0;
}

input{
	border-bottom: 1px dotted var(--dark-grey);
	padding: 5px;
}

.results {
  opacity: 1;
  max-height: 0;
  overflow: hidden;
  transition: 0.7s;
	background-color: var(--dark-grey);
  color: white;
  
  &.active {
    opacity: 1;
    max-height: 1200px;
    margin-bottom: 10px;
  }

	.block{
		margin-top: 5px;
    border-bottom: 1px solid white;
    padding: 10px;
	}
	
	.block:last-of-type{
    border-bottom: 1px solid transparent;
	}
	
	.block > span{
		font-family: Arial, sans-serif;
		font-weight: bold;
		color: white;
		margin-bottom: 7px;
    display: block;
    margin-top: 0px;
	}
	
	ul{
		@util reset-list;
	}
	
	li{
		display: inline;
    font-size: 12px;
    font-family: "Arial", sans-serif;
    margin-right: 30px;
		
		a{
			span{
			color: white;
			}
		}
	}
	
	li:hover{
		a{
			span{
				color: var(--light_purple);
			}
		}
	}
}

.results-inner{
	padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/vue/components/Autocomplete.vue